import { DatePicker } from '@/components/DatePicker'
import { useTranslation } from '@/hooks/use-translation'
import { useDateRangeFilter } from '../../hooks/use-date-range-filter'
import type { DateFilterValue, DateRangeFilterProps } from '../../types/data-table.types'

export function DateRangeFilter({ columnId, columnTitle, value, onChange }: DateRangeFilterProps) {
  const t = useTranslation()
  const { handleFromChange, handleToChange, fromDate, toDate, hasValidationError } =
    useDateRangeFilter(value as DateFilterValue | undefined, onChange)

  return (
    <div className="space-y-1">
      <label htmlFor={`filter-date-${columnId}`} className="text-xs font-medium">
        {columnTitle}
      </label>
      <div className="space-y-1">
        <div className="flex space-x-2">
          <div className="flex-1">
            <DatePicker
              id={`filter-date-from-${columnId}`}
              label={t('dataTable.from')}
              placeholder={t('dataTable.from')}
              value={fromDate}
              onChange={handleFromChange}
              maxDate={toDate}
              className="space-y-1"
            />
          </div>
          <div className="flex-1">
            <DatePicker
              id={`filter-date-to-${columnId}`}
              label={t('dataTable.to')}
              placeholder={t('dataTable.to')}
              value={toDate}
              onChange={handleToChange}
              minDate={fromDate}
              className="space-y-1"
            />
          </div>
        </div>
        {hasValidationError && (
          <p className="text-xs text-destructive">{t('dataTable.fromGreaterThanTo')}</p>
        )}
      </div>
    </div>
  )
}
